import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import sw from './sw.json';

const STORAGE_KEY = 'lang';

const languageDetector = {
    init: Function.prototype,
    type: 'languageDetector',
    async: true,
    detect: async (callback) => {
        try {
            const savedDataJSON = await localStorage.getItem(STORAGE_KEY);
            const lng = savedDataJSON ? savedDataJSON : 'en';
            callback(lng);
        } catch (err) {
            console.error('Error detecting language:', err);
            callback('en'); // Fallback to 'en' in case of an error
        }
    },
    cacheUserLanguage: async (lng) => {
        try {
            await localStorage.setItem(STORAGE_KEY, lng);
        } catch (err) {
            console.error('Failed to save language:', err);
        }
    }
};

i18next
    .use(languageDetector)
    .use(initReactI18next)
    .init({
        compatibilityJSON: 'v3',
        fallbackLng: 'en',
        resources: { en, sw },
        debug: false,
        interpolation: {
            escapeValue: false
        },
        react: {
            useSuspense: false
        }
    });

export default i18next;
